<template>
  <span v-if="masterContactIDs.length" class="genvite-profile-label">
    <span v-for="(id, index) in masterContactIDs" :key="id">
      <span v-if="index === 0">Genvite ID: </span>
      <span v-else>, </span>
      <a
        href="#"
        class="genvite-profile-link"
        @click.prevent="openGenvitePortal(id)"
        >{{ id }}</a
      >
    </span>

    <v-dialog
      v-model="genvitePortalDialog"
      max-width="1400"
      content-class="genvite-portal-dialog"
    >
      <v-card>
        <v-card-title class="headline py-2">
          Genvite Portal - Contact ID: {{ genviteMasterContactID }}
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            class="mr-2"
            @click="openGenviteExternal"
          >
            <v-icon left>mdi-open-in-new</v-icon>Open in new tab
          </v-btn>
          <v-btn class="my-0" icon @click="genvitePortalDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <iframe
            v-if="genvitePortalUrl"
            :src="genvitePortalUrl"
            class="genvite-portal-iframe"
          ></iframe>
          <div
            class="px-4 pb-2 pt-1 caption grey--text"
            v-if="genvitePortalUrl"
          >
            If you see a login loop, this site may block authentication inside
            an embedded window. Use "Open in new tab" above.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  props: {
    utaId: {
      type: String,
      default: "",
    },
    accountId: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    masterContactIDs: [],
    genvitePortalDialog: false,
    genvitePortalUrl: null,
    genviteMasterContactID: null,
  }),
  computed: {
    linkQuery() {
      const accountId = this.accountId != null ? String(this.accountId).trim() : "";
      const utaId = this.utaId != null ? String(this.utaId).trim() : "";
      if (accountId) return "accountID=" + encodeURIComponent(accountId);
      if (utaId) return "utaID=" + encodeURIComponent(utaId);
      return "";
    },
  },
  watch: {
    linkQuery: {
      immediate: true,
      handler(query) {
        this.loadLink(query);
      },
    },
  },
  methods: {
    async loadLink(query) {
      this.masterContactIDs = [];
      this.genvitePortalDialog = false;
      this.genvitePortalUrl = null;
      this.genviteMasterContactID = null;

      if (!query) {
        this.$emit("linked", false);
        return;
      }

      try {
        const result = await this.$http.get("api/genvite/getLink?" + query);
        const ids =
          result && Array.isArray(result.masterContactIDs)
            ? result.masterContactIDs
            : [];
        this.masterContactIDs = ids
          .map((value) => (value != null ? String(value).trim() : ""))
          .filter((value) => value);
      } catch (e) {
        this.masterContactIDs = [];
      }

      this.$emit("linked", this.masterContactIDs.length > 0);
    },
    getGenviteAppUser() {
      return this.$store &&
        this.$store.state &&
        this.$store.state.authentication
        ? this.$store.state.authentication.user || ""
        : "";
    },
    buildGenvitePortalUrl(masterContactID) {
      const masterId = masterContactID != null ? String(masterContactID) : "";
      const apiKey =
        "ee81f16620d0455d89aabdd9c12bd214c10b3c5619b8412786cba4163a3ebbdd";
      const localUser = this.getGenviteAppUser();
      return (
        "https://portal.genvite.com/app/premium?id=" +
        encodeURIComponent(masterId) +
        "&apikey=" +
        encodeURIComponent(apiKey) +
        "&localuser=" +
        encodeURIComponent(localUser)
      );
    },
    openGenvitePortal(masterContactID) {
      this.genviteMasterContactID = masterContactID;
      this.genvitePortalUrl = this.buildGenvitePortalUrl(masterContactID);
      this.genvitePortalDialog = true;
    },
    openGenviteExternal() {
      if (this.genvitePortalUrl) {
        window.open(this.genvitePortalUrl, "_blank");
      }
    },
  },
};
</script>

<style>
.genvite-profile-label {
  margin-left: 12px;
  font-size: 14px;
  white-space: nowrap;
}
.genvite-profile-link {
  color: rgb(32, 166, 237);
  text-decoration: none;
}
.genvite-profile-link:hover {
  text-decoration: underline;
}
.genvite-portal-dialog {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
  max-height: calc(100vh - 24px) !important;
}
.genvite-portal-dialog .v-card {
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
}
.genvite-portal-dialog .v-card__text {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.genvite-portal-iframe {
  width: 100%;
  flex: 1 1 auto;
  height: calc(100vh - 170px);
  min-height: 0;
  border: none;
  display: block;
}
</style>
